module.exports = __webpack_public_path__ + "img/logo.0652c894.jpg";